module.exports = __webpack_public_path__ + "img/大理国际1.bae43052.png";